import {Action, createReducer, on} from '@ngrx/store';
import {
  TemplateSectionTypeList,
  TemplateSectionTypeListSuccess,
  TemplateSectionTypeListError,
  ResetTemplateSectionState,
  TemplateSectionListAll,
  TemplateSectionListAllSuccess,
  TemplateSectionListAllError
} from '@app/stores/template-section/template-section.actions';
import {initialTemplateSectionState} from '@app/stores/template-section/template-section.state';

const generateReducer = createReducer(initialTemplateSectionState,
  on(TemplateSectionListAll, (state) => ({
    ...state,
    templateSections: [],
    success: '',
    error: ''
  })),
  on(TemplateSectionListAllSuccess, (state, {templateSections}) => ({
    ...state,
    templateSections,
    success: '',
    error: ''
  })),
  on(TemplateSectionListAllError, (state, {error}) => ({
    ...state,
    templateSections: [],
    success: '',
    error
  })),

  on(TemplateSectionTypeList, (state) => ({
    ...state,
    templateSectionTypes: [],
    success: '',
    error: ''
  })),
  on(TemplateSectionTypeListSuccess, (state, {templateSectionTypes}) => ({
    ...state,
    templateSectionTypes,
    success: '',
    error: ''
  })),
  on(TemplateSectionTypeListError, (state, {error}) => ({
    ...state,
    templateSectionTypes: [],
    success: '',
    error
  })),

  on(ResetTemplateSectionState, (state, {params}) => ({
    ...state,
    ...params
  })),
);

export function templateSectionReducer(state = initialTemplateSectionState, action: Action) {
  return generateReducer(state, action);
}
